import React, { useEffect, useState } from "react";
import { settingService } from "../../../services/extensions";
import { PickList } from "primereact/picklist";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import { Toolbar } from "primereact/toolbar";
import { Util } from "../../../services";
import { InputSwitch } from 'primereact/inputswitch';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../services/store/userSlice';
function ActivityMapping() {
  const user = useSelector(selectUser);
  const empIndex = user.roles.indexOf('Masters Admin', 'Users Admin', 'ADMIN');
  const [projects, setProjects] = useState([]);
  const [masterActivity, setMasterActivity] = useState([]);
  const [filterMasterActivity, setFilterMasterActivity] = useState([]);
  const [activity, setActivity] = useState([]);
  const [selProject, setSelProject] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [billableNonBillable, setBillableNonBillable] = useState(true);

  useEffect(() => {
    getProjectsByUser();
    getMasterActivity();
  }, []);

  const filterProject = (data) => {
    settingService.getActivityById(data.id).then((resp) => {
      setSelProject(data);
      let restMaserArray;
      if (billableNonBillable) {
        let masterActivityList = filterMasterActivity.filter((i) => {
          return i.isBillable;
        });
        restMaserArray = masterActivityList.filter(
          ({ title: id1, isBillable: id3 }) =>
            !resp.data.data.some(({ title: id2, isBillable: id4 }) => id2 === id1 && id4 === id3)
        );
      } else {
        let masterActivityList = filterMasterActivity.filter((i) => {
          return !i.isBillable;
        });
        restMaserArray = masterActivityList.filter(
          ({ title: id1, isBillable: id3 }) =>
            !resp.data.data.some(({ title: id2, isBillable: id4 }) => id2 === id1 && id4 === id3)
        );
      }
      setMasterActivity(restMaserArray);
      setActivity(resp.data.data);
    });
  };

  const getProjectsByUser = () => {
    if (empIndex === 1) {
      settingService.getProjects().then(resp => {
        setProjects(resp.data.data);
      });
    } else {
      settingService.getProjectsByUser().then((resp) => {
        setProjects(resp.data.data);
      });
    }
  };

  const getMasterActivity = () => {
    settingService.getAllMasterActivity().then((resp) => {
      var masterActivityList = [];
      masterActivityList = resp.data.data.filter((i) => {
        return i.isBillable;
      });
      setMasterActivity(masterActivityList);
      setFilterMasterActivity(resp.data.data);
    });
  };

  const onChange = (event) => {
    if (selProject.length === 0) {
      toast.error("Please select Project!");
      return 1;
    }
    // moving all element source to target
    if (event.source.length === 0 && event.target.length !== 0) {
      var selectedSource = [];
      event.target.map((item) => {
        if (!item.projectId) {
          selectedSource.push(item);
        }
      });
      var proListing = [];
      selectedSource.map((item) => {
        let objProject = {
          projectId: selProject.id,
          code: item.code,
          title: item.title,
          isBillable: item.isBillable,
          type: item.type,
        };
        proListing.push(objProject);
      });
      let param = proListing;
      settingService.addActivityInBulk(param).then((resp) => {
        setMasterActivity(event.source);
        setActivity(event.target);
        filterProject(selProject);
      });
      return true;
    }

    if (event.target.length === 0 && event.source.length !== 0) {
      settingService.deleteActivityByProjectId(selProject.id).then((resp) => {
        setMasterActivity(event.source);
        setActivity(event.target);
        filterProject(selProject);
      });
      return true;
    }

    if (selProject.length != 0) {
      if (selectedType === "source") {
        var proListing = [];
        selectedRowData.map((item) => {
          let objProject = {
            projectId: selProject.id,
            code: item.code,
            title: item.title,
            isBillable: item.isBillable,
            type: item.type,
          };
          proListing.push(objProject);
        });
        let param = proListing;
        settingService.addActivityInBulk(param).then((resp) => {
          setMasterActivity(event.source);
          setActivity(event.target);
          filterProject(selProject);
        });
      }

      if (selectedType === "target") {
        let id = selectedRowData[0].id;
        settingService.deleteActivityById(id).then((resp) => {
          setMasterActivity(event.source);
          setActivity(event.target);
          filterProject(selProject);
        });
      }
    }
  };

  const onSourceSelectionChange = (e) => {
    setSelectedRowData(e.value);
    setSelectedType("source");
  };
  const onTargetSelectionChange = (e) => {
    setSelectedRowData(e.value);
    setSelectedType("target");
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div>
          <h3>Select Project</h3>
          <Dropdown filter id="project_list" name="project_list" options={projects} value={selProject} onChange={(e) => filterProject(e.value)} optionLabel="title" placeholder="Select Project" style={{ minWidth: "180px" }} />
        </div>
        
      </React.Fragment>
    );
  };

  const changeBillableNonBillable = (e) => {
    var masterActivityList = [];
    if(selProject.id){
      if (e.value) {
        let billableActivityList = filterMasterActivity.filter((i) => {
          return i.isBillable;
        });
        masterActivityList = billableActivityList.filter(
          ({ title: id1, isBillable: id3 }) =>
            !activity.some(({ title: id2, isBillable: id4 }) => id2 === id1 && id4 === id3)
        );
      } else {
        let billableActivityList = filterMasterActivity.filter((i) => {
          return !i.isBillable;
        });
        masterActivityList = billableActivityList.filter(
          ({ title: id1, isBillable: id3 }) =>
            !activity.some(({ title: id2, isBillable: id4 }) => id2 === id1 && id4 === id3)
        );
      }
    } else {
      if (e.value) {
        masterActivityList = filterMasterActivity.filter((i) => {
          return i.isBillable;
        });
      } else {
        masterActivityList = filterMasterActivity.filter((i) => {
          return !i.isBillable;
        });
      }
    }
    setMasterActivity(masterActivityList);
    setFilterMasterActivity(filterMasterActivity);
    setBillableNonBillable(e.value);
  }

  const leftToolBarTemplate = () => {
    return (
      <React.Fragment>
        <div className="mr-4"><strong>Filter By Activity (Non-Billable) </strong></div> <InputSwitch checked={billableNonBillable} onChange={(e) => changeBillableNonBillable(e)} /> <div className="ml-4"><strong>(Billable) </strong></div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div>
        <Toolbar className="mb-2" left={leftToolBarTemplate} right={rightToolbarTemplate}></Toolbar>
      </div>
      <PickList
        filterBy="title"
        source={masterActivity}
        target={activity}
        itemTemplate={Util.activityItemBody}
        sourceHeader="Master Activity"
        targetHeader="Project Activity"
        sourceStyle={{ height: "23.6vw" }}
        targetStyle={{ height: "23.6vw" }}
        onChange={onChange}
        onSourceSelectionChange={(e) => onSourceSelectionChange(e)}
        onTargetSelectionChange={(e) => onTargetSelectionChange(e)}
        className="col-8 col-offset-2"
        // style={{ marginLeft: "13vw" }}
        showSourceControls={false}
        showTargetControls={false}
      />
    </React.Fragment>
  );
}

export default ActivityMapping;
